(() => {
  const selector = '[data-category-promo-cards]';
  const instances = new WeakMap();

  class CategoryPromoCards {
    constructor(section) {
      if (instances.has(section)) return;
      this.section = section;
      this.cards = [...section.querySelectorAll('[data-category-promo-card]')];
      this.cards.forEach(card => card.classList.add('is-visible'));
      instances.set(section, this);
    }

    reveal(block) {
      block.closest('[data-category-promo-card]')?.classList.add('is-visible');
    }

    destroy() {
      instances.delete(this.section);
    }
  }

  const init = scope => scope.querySelectorAll(selector).forEach(section => new CategoryPromoCards(section));
  const getInstance = target => {
    const section = target.closest(selector);
    return section ? instances.get(section) : null;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll(selector).forEach(section => instances.get(section)?.destroy()));
  document.addEventListener('shopify:block:select', event => getInstance(event.target)?.reveal(event.target));
})();
